var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(
		() =>
			_vm.offset
				? _vm.onClick({
						offset: _vm.offset,
						userId:
							'userId' in (_vm.currentRetailer || {})
								? _vm.currentRetailer.userId
								: _vm.selfUserId
				  })
				: {}
	),expression:"\n\t\t() =>\n\t\t\toffset\n\t\t\t\t? onClick({\n\t\t\t\t\t\toffset: offset,\n\t\t\t\t\t\tuserId:\n\t\t\t\t\t\t\t'userId' in (currentRetailer || {})\n\t\t\t\t\t\t\t\t? currentRetailer.userId\n\t\t\t\t\t\t\t\t: selfUserId\n\t\t\t\t  })\n\t\t\t\t: {}\n\t"}],attrs:{"infinite-scroll-disabled":!_vm.loading,"infinite-scroll-distance":"100","infinite-scroll-throttle-delay":"100","min-height":"100vh"}},_vm._l((_vm.items),function(item){return _c('div',{key:item.userId},[_c('associate-card',{attrs:{"associateData":item,"isFixed":false,"jeet11Color":_vm.jeet11Color,"rummyColor":_vm.rummyColor},on:{"ON_CLICK":function($event){return _vm.onClick(item)},"GO_BACK":_vm.goBack}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }